import * as pdfjs from 'pdfjs-dist';

let workerConfigured = false;

export function configurePdfWorker() {
    if (workerConfigured) {
        return;
    }

    pdfjs.GlobalWorkerOptions.workerSrc = new URL(
        'pdfjs-dist/build/pdf.worker.min.mjs',
        import.meta.url,
    ).toString();

    workerConfigured = true;
}

export { pdfjs };
